import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import TeamRolLabel from "./TeamRolLabel";

/**
 * Glasronde 0.9.234 (Frank 2 november 2026) punt 1 en 2: bovenaan Code, naast de naam, bij welk team de repo van deze
 * werkruimte hoort en jouw rol. Niets bij een werkruimte zonder repo of bij een persoonlijke repo.
 */
export default function CodeTeamLabel({ repoId }) {
  const [repo, setRepo] = useState(null);
  useEffect(() => {
    if (!repoId) return;
    axios.get(`${API}/repos/${repoId}`).then((r) => setRepo(r.data)).catch(() => setRepo(null));
  }, [repoId]);
  if (!repo?.team_naam) return null;
  return <TeamRolLabel teamNaam={repo.team_naam} rol={repo.rol} testid="code-team-rol" />;
}
